import React from 'react';

// Small uppercase label above a section inside a card (e.g. "SALES LIMIT").
const SectionHeading = ({ children }) => (
  <h5 className="text-[11px] font-medium uppercase tracking-wider text-gray-400 dark:text-muted-foreground">
    {children}
  </h5>
);

export default SectionHeading;
